import { render, staticRenderFns } from "./ReceiveModalForm.vue?vue&type=template&id=8a210112"
import script from "./ReceiveModalForm.vue?vue&type=script&lang=js"
export * from "./ReceiveModalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports